import React, { Fragment, useEffect } from 'react'
import { Object3D, Vector2, Vector3 } from 'three'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import { dispatch, EVENTS_OBJECTS } from '../../b.providers/EventsProvider/EventsProvider'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'
import Electron from '../../e.elements/Electron/Electron'
import GameElement from '../../e.elements/GameElements/GameElement/GameElement'
import { coordsToPosition } from '../../e.elements/Grid/scripts/helpers/coordsPositionConverter'
import Jack from '../../f.assets/Characters/components/Jack/Jack'
import Witch from '../../f.assets/Characters/components/Witch/Witch'
import { CHARACTER_TYPES } from '../../f.assets/Characters/scripts/constants'
import { SEL_GRID_ORIGIN } from '../TerrainManager/selectors'
import { COMMANDERS, Player } from './store.d'

const Belligerents = ({ data }: { data: Player[] }) => {
  const gridOrigin = useSceneStore(SEL_GRID_ORIGIN)
  const clearThrowMagic = useSceneStore.getState().levels.clearThrowMagic
  const belligerents = useSceneStore(s => s.levels.data.players)
  const homeTeam = useScenesStore(s => s.user.team)

  const onCompleteThrowingMagic = (belligerent: COMMANDERS) => {
    clearThrowMagic(belligerent)
    dispatch(EVENTS_OBJECTS.MAGIC_IMPACT, null)
  }

  const homeCommanderCoords = new Vector2(-2, 9)
  const awayCommanderCoords = new Vector2(17, 1)
  const awayTeam = homeTeam === CHARACTER_TYPES.JACK ? CHARACTER_TYPES.WITCH : CHARACTER_TYPES.JACK
  return (
    <>
      {belligerents.map(b => {
        const team = b.id === COMMANDERS.PLAYER ? homeTeam : awayTeam
        const commanderCoords = b.id === COMMANDERS.PLAYER ? homeCommanderCoords : awayCommanderCoords
        
        if (team === CHARACTER_TYPES.JACK) {
          const commanderPostion = coordsToPosition(commanderCoords, gridOrigin)
          // console.log(commanderPostion)
          return (
            <Fragment key={`commander_${team}`}>
              <GameElement position={commanderPostion} onStart={(obj: Object3D) => obj.lookAt(new Vector3(0, 0, 0))}>
                <Jack scale={[1.5, 1.5, 1.5]} />
              </GameElement>
              {b.magicThrown && (
                <Electron
                  position={[0, 0, 0]}
                  origin={commanderPostion}
                  destination={b.magicThrown.destination}
                  speed={6}
                  onComplete={() => onCompleteThrowingMagic(b.magicThrown?.owner!)}
                />
              )}
            </Fragment>
          )
        }
        if (team === CHARACTER_TYPES.WITCH) {
          const commanderPostion = coordsToPosition(commanderCoords, gridOrigin)
          return (
            <Fragment key={`commander_${team}`}>
              <GameElement position={commanderPostion} onStart={(obj: Object3D) => obj.lookAt(new Vector3(0, 0, 0))}>
                <Witch scale={[1.5, 1.5, 1.5]} />
              </GameElement>
              {b.magicThrown && (
                <Electron
                  position={[0, 0, 0]}
                  origin={commanderPostion}
                  destination={b.magicThrown.destination}
                  speed={6}
                  onComplete={() => onCompleteThrowingMagic(b.magicThrown?.owner!)}
                />
              )}
            </Fragment>
          )
        }
      })}
    </>
  )
}
export default Belligerents

// React.memo()
